var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        "before-close": _vm.close,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        open: _vm.openDialog,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dia-tit", attrs: { slot: "title" }, slot: "title" },
        [
          _c("i"),
          _c("span", {
            domProps: { textContent: _vm._s(_vm.curriculumTitle) },
          }),
        ]
      ),
      _c(
        "el-form",
        {
          ref: "formData",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "所属分组：", prop: "courseGroup" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择所属分组" },
                  on: { change: _vm.change },
                  model: {
                    value: _vm.formData.courseGroup,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "courseGroup", $$v)
                    },
                    expression: "formData.courseGroup",
                  },
                },
                _vm._l(_vm.courseGroupList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "所属分类：", prop: "catalogId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择所属分类" },
                  model: {
                    value: _vm.formData.catalogId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "catalogId", $$v)
                    },
                    expression: "formData.catalogId",
                  },
                },
                _vm._l(_vm.catalogIdList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "课程名称：", prop: "title" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入课程名称（不可重名）",
                  maxlength: "16",
                },
                model: {
                  value: _vm.formData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "title", $$v)
                  },
                  expression: "formData.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "课程昵称：" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入课程昵称（展示给购课学员）",
                  maxlength: "64",
                },
                model: {
                  value: _vm.formData.nick,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "nick", $$v)
                  },
                  expression: "formData.nick",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "课程类型：", prop: "type" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择课程类型" },
                  model: {
                    value: _vm.formData.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "type", $$v)
                    },
                    expression: "formData.type",
                  },
                },
                _vm._l(
                  _vm.formData.courseGroup == "培训"
                    ? _vm.typeLists
                    : _vm.typeList,
                  function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _vm.formData.courseGroup === "编程"
            ? _c(
                "el-form-item",
                { attrs: { label: "课程账号类型：", prop: "series" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择课程账号类型" },
                      model: {
                        value: _vm.formData.series,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "series", $$v)
                        },
                        expression: "formData.series",
                      },
                    },
                    _vm._l(_vm.cascaderList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.courseGoodsName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticClass: "dialog-btn",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.saveCategory()
                },
              },
            },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              staticClass: "dialog-btn",
              attrs: { type: "info" },
              on: { click: _vm.close },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }